import { FAST_CHECKOUT_PRODUCTS_BR, FAST_CHECKOUT_CYCLES, FAST_CHECKOUT_PAYMENT_METHODS } from '@/pages/FastCheckout/FastCheckout.enum.jsx';
import HostGatorStudioIcon from '@/pages/FastCheckout/media/studio-pro-icon.svg';
import React from 'react';

export default {
  backButton: 'Voltar',
  cartTitle: 'Carrinho',
  resumeTitle: 'Resumo da compra',
  product: 'Produto',
  renewal: 'Próxima renovação ',
  total: 'Total da compra: ',
  value: 'Valor: ',
  discountTag: 'Desconto',
  ctaPurchase: 'Finalizar compra',
  securityReminder: 'Transação segura e criptografada',
  confirmPaymentLoading: 'Estamos preparando tudo para você...',
  errorToast: 'Ocorreu um erro inesperado, tente novamente mais tarde',
  purchaseErrorToast: {
    title: 'Seu pagamento não foi concluído',
    description: 'Confira os dados do cartão, o saldo ou tente com outro cartão de crédito.',
  },
  paymentTitle: 'Pagamento',
  renewalSamePaymentMethod: (
    <>
      <span>Renovação Automática: </span>
      Esse produto será renovado automaticamente no cartão de crédito cadastrado. Você pode cancelar a qualquer hora em assinaturas.
    </>
  ),
  renewalSamePaymentMethodInTrial: (
    <>
      <span>Importante: </span>
      Só cobramos no cartão depois dos 7 dias de teste. Vamos te avisar no seu e-mail antes do fim do período de teste.
    </>
  ),
  taxToolTip: {
    title: 'Impostos e tarifas',
    description: 'A aplicação do imposto IVA/IVA pode ser identificada nos tipos de compras:',
    topics: [
      {
        id: 1,
        text: 'Compras realizadas por pessoas físicas no site da HostGator Argentina',
      },
      {
        id: 2,
        text: 'As ocorrências nos sites da HostGator por pessoas residentes no território europeu',
      },
    ],
  },
  cycles: {
    [FAST_CHECKOUT_CYCLES.MONTHLY]: 'Plano mensal',
    [FAST_CHECKOUT_CYCLES.QUARTERLY]: 'Plano trimestral',
    [FAST_CHECKOUT_CYCLES.SEMIANNUALLY]: 'Plano semestral',
    [FAST_CHECKOUT_CYCLES.ANNUALLY]: 'Plano anual',
  },
  paymentMethods: {
    [FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD]: {
      label: 'Preencha os dados do cartão de crédito',
      ccAlreadyRegistered: 'Cartão cadastrado',
      newCC: 'Novo Cartão de Crédito',
      alreadyRegisteredTitle: 'Informações do cartão cadastrado',
      nextPayment: 'Próximo pagamento',
      expire: 'Vencimento: ',
      dateGrouper: 'de',
    },
  },
  products: {
    [FAST_CHECKOUT_PRODUCTS_BR.STUDIO_PRO]: {
      name: 'HostGator Studio Pro',
      defaultCycle: FAST_CHECKOUT_CYCLES.MONTHLY,
      defaultPaymentMethod: FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD,
      icon: HostGatorStudioIcon,
      isTrial: false,
      productHasSpecialRuleForDiscount: true,
      isAUpgrade: true,
    },
    [FAST_CHECKOUT_PRODUCTS_BR.STUDIO_PRO_TRIAL]: {
      name: 'HostGator Studio Pro',
      defaultCycle: FAST_CHECKOUT_CYCLES.MONTHLY,
      defaultPaymentMethod: FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD,
      icon: HostGatorStudioIcon,
      isTrial: true,
      productHasSpecialRuleForDiscount: true,
      isAUpgrade: true,
    },
  },
  successPage: {
    title: 'Pagamento concluído',
    description: (
      <>
        Parabéns! Seu pagamento foi realizado.
        <br />
        Em breve, você receberá um e-mail de confirmação.
      </>
    ),
    ctaLabel: 'Ok, entendi',
  },
};
